import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewFollowers = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 57.40157 57.40625",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "newFollowers" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.732,46.125,28.70079,56.15625h-.03125L18.63829,46.125h-8.5a3.875,3.875,0,0,1-3.875-3.875V5.125a3.875,3.875,0,0,1,3.875-3.875h37.125a3.875,3.875,0,0,1,3.875,3.875V42.25a3.875,3.875,0,0,1-3.875,3.875Z",
			style: {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.777,33.37757v3.80307s-4.16007,5.58807-14.06855,5.46423c-9.91573.12384-14.08309-5.46423-14.08309-5.46423V33.37757c1.45713-2.63015,9.7263-5.0271,9.7263-5.0271V24.16123a11.83148,11.83148,0,0,1-2.1784-5.48606l-.53913-3.08185V13.03606a7.07434,7.07434,0,0,1,14.14868,0v2.55726l-.51,3.0891A12.08483,12.08483,0,0,1,33.058,24.16123v4.18924S41.33442,30.74742,42.777,33.37757Z",
			style: {
				fill: "#FFFFFF",
				stroke: "#FFFFFF",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})
	]
});
export default SvgNewFollowers;
